import { render } from "./Default.vue?vue&type=template&id=b445ec3a&scoped=true&ts=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"

import "./Default.vue?vue&type=style&index=0&id=b445ec3a&scoped=true&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b445ec3a"]])

export default __exports__